module.exports = __webpack_public_path__ + "img/hello-fresh-logo.7ed05f8c.png";